import React, { Component } from "react";
import { inject } from "mobx-react";
import PropTypes from "prop-types";
import {
  Modal,
  Loader,
  GridContainer,
  GridRow,
  GridColumn,
} from "arv-reactcomponents";
import LoyaltyTiersBlock from "./LoyaltyTiersBlock";
import { MYACCOUNTPAGE, Endpoints } from "npmlinks-constants";

const {
  LOYALTY: {
    NO_TIERS_MSG,
    MORE_INFO_TITLE_SUFFIX,
    BURN,
    CONVERSION,
    EXPIRY,
    TIER_DOWNGRADE,
  },
} = MYACCOUNTPAGE;

// eslint-disable-next-line react/prefer-stateless-function
class LoyaltyMoreInfoModal extends Component {
  render() {
    const {
      data: {
        brand,
        tiers,
        expiry_criteria,
        points_conversion,
        burn_cap,
        tier_downgrade_criteria,
      },
      isOpen,
      onClose,
      loading,
    } = this.props;

    const DEFAULT_VALUE = "NA";

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        className="nw-loyaltymoreinfo-modal"
      >
        {loading && (
          <div className="nw-loyaltymodal-loading nwc-translucentbackground-white">
            <Loader />
          </div>
        )}
        <div>
          <h1 className="nw-loyaltymoreinfo-title">
            {brand} {MORE_INFO_TITLE_SUFFIX}
          </h1>
          <GridContainer className="nw-loyaltymodal-container">
            <GridRow>
              <GridColumn>
                {tiers && tiers.length ? (
                  <LoyaltyTiersBlock.component tiers={tiers} />
                ) : (
                  <div className="nw-loyaltymodal-notiers">{NO_TIERS_MSG}</div>
                )}
              </GridColumn>
            </GridRow>
            <GridRow className="nw-loyaltymodal-extrainforow nw-loyaltymodal-textcenter">
              <GridColumn className="nwc-grid-col-sm-3 nw-loyaltymodal-icomoon-col">
                <i className="nw-loyaltymodal-icon icomoon-loyalty_burn nw-loyaltymodal-burnicon" />
                <div className="nw-loyaltymodal-extrainfoprimarytext">
                  {BURN}
                </div>
                <p className="nw-loyaltymodal-secondarytext">
                  {burn_cap || DEFAULT_VALUE}
                </p>
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-3 nw-loyaltymodal-icomoon-col">
                <i className="nw-loyaltymodal-icon icomoon-loyalty_earn nw-loyaltymodal-conversionicon" />
                <div className="nw-loyaltymodal-extrainfoprimarytext">
                  {CONVERSION}
                </div>
                <p className="nw-loyaltymodal-secondarytext">
                  {points_conversion || DEFAULT_VALUE}
                </p>
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-3 nw-loyaltymodal-icomoon-col">
                <i className="nw-loyaltymodal-icon icomoon-sand_loader nw-loyaltymodal-expiryicon" />
                <div className="nw-loyaltymodal-extrainfoprimarytext">
                  {EXPIRY}
                </div>
                <p className="nw-loyaltymodal-secondarytext">
                  {expiry_criteria || DEFAULT_VALUE}
                </p>
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-3 nw-loyaltymodal-icomoon-col">
                <i className="nw-loyaltymodal-icon icomoon-loyalty_downgrade nw-loyaltymodal-downgradeicon" />
                <div className="nw-loyaltymodal-extrainfoprimarytext">
                  {TIER_DOWNGRADE}
                </div>
                <p className="nw-loyaltymodal-secondarytext">
                  {tier_downgrade_criteria || DEFAULT_VALUE}
                </p>
              </GridColumn>
            </GridRow>
          </GridContainer>
        </div>
      </Modal>
    );
  }
}

LoyaltyMoreInfoModal.propTypes = {
  data: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    tiers: PropTypes.arrayOf(PropTypes.object).isRequired,
    expiry_criteria: PropTypes.string.isRequired,
    points_conversion: PropTypes.string.isRequired,
    burn_cap: PropTypes.string.isRequired,
    tier_downgrade_criteria: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: LoyaltyMoreInfoModal,
  component: LoyaltyMoreInfoModal,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/MyAccountLoyalty/LoyaltyMoreInfoModal/index.js